<template>
  <v-container ma-0 pa-0>
    <v-layout justify-center row wrap>
      <v-flex xs12 ma-0 pa-0>
        <v-toolbar flat>
            <v-toolbar-title>MCTC Administration</v-toolbar-title>
            <v-spacer></v-spacer>
            <!-- <v-toolbar-items class="hidden-sm-and-down">
              <v-btn flat>Club Records</v-btn>
              <v-btn flat>Stats</v-btn>
              <v-btn flat>Board</v-btn>
            </v-toolbar-items> -->
          </v-toolbar>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 md4 pa-2>
        <v-card>
          <v-card-title><h2 class="subheading">Membership Stats</h2></v-card-title>
          <v-card-text>
            Total Web Accounts: {{memberStats.total}}<br/>
            Registered Members: {{memberStats.registered}}<br/>
            Active Memberships: {{memberStats.active}}<br/>
            Membership Renewals Due/Expired: {{memberStats.expired}}<br/>
            Board Members: {{memberStats.board}}<br/>
            Active Committee Members: {{memberStats.committeeActive}}<br/>
            Members Volunteering for Committee Duty: {{memberStats.committeeOptIn}}<br/>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 md4 pa-2>
        <v-card>
          <v-card-title><h2 class="subheading">Upcoming Events</h2></v-card-title>
          <v-card-text><em>TBD</em></v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 md4 pa-2>
        <v-card>
          <v-card-title><h2 class="subheading">Committee Meetings:</h2></v-card-title>
          <v-card-text>Next Scheduled Meeting: <em>TBD</em></v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- <v-layout row wrap>
      <v-flex xs12 md4 pa-2 ma-1>
        <v-card>
          <v-card-title><h2 class="subheading">Committee Meetings:</h2></v-card-title>
          <v-card-text>Next Scheduled Meeting: 20th August 6:00pm</v-card-text>
        </v-card>
      </v-flex>
    </v-layout> -->
  </v-container>
</template>

<script>
import store from '@/store'
// import TestMemeberList from '@/data/TestAccountMembers'
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    user () {
      return store.state.user
    },
    ...mapGetters({
      memberStats: 'getMemberStats'
    })
  },
  methods: {
    next () {
      const active = parseInt(this.active)
      this.active = (active < 2 ? active + 1 : 0)
    },
    ...mapActions([
      'getMemberStats'
    ])
  },
  data () {
    return {
      active: null
      // members: TestMemeberList
    }
  },
  mounted () {
    this.getMemberStats()
  }
}
</script>
<style>
  #specialOffer {
    font-size: 2rem;
    background-color: darkgreen;
    padding: 5px 20px;
    border-radius: 3px;
    width: fit-content;
    color: white;
  }
</style>
